module.exports = __webpack_public_path__ + "img/f1.f9907a5d.png";